import _jsx from "@babel/runtime/helpers/jsx";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { memo, useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import SectionMenu from 'components/SectionMenu';
import { MoreInfoWrapper, MoreInfoTitle, MoreInfoBlock, MoreInfoItem, MoreInfoItemTitle, MoreInfoItemContent, MoreInfoItemContentList, MoreInfoItemContentItem } from './styles';

function CardItemMoreInfo(_ref) {
  var card = _ref.card,
      menuItems = _ref.menuItems,
      handleSetMenuItems = _ref.handleSetMenuItems,
      isShowMoreInfo = _ref.isShowMoreInfo;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var activeItem = useMemo(function () {
    return menuItems.find(function (el) {
      return el.isActive;
    });
  }, [menuItems]);
  var activeItemParams = useMemo(function () {
    return activeItem.getParams(_objectSpread({}, card));
  }, [activeItem]);
  var showList = useCallback(function (param) {
    return !!activeItemParams[param].length && /*#__PURE__*/_jsx(MoreInfoItemContentList, {}, void 0, activeItemParams[param].map(function (el, index) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        _jsx(MoreInfoItemContentItem, {}, index, el)
      );
    })) || '-';
  }, [activeItemParams]);
  return /*#__PURE__*/_jsx(MoreInfoWrapper, {
    isShowMoreInfo: isShowMoreInfo
  }, void 0, /*#__PURE__*/_jsx(SectionMenu, {
    menuItems: menuItems,
    setMenu: handleSetMenuItems
  }), /*#__PURE__*/_jsx(MoreInfoTitle, {}, void 0, activeItem.name), /*#__PURE__*/_jsx(MoreInfoBlock, {}, void 0, Object.keys(activeItemParams).map(function (param) {
    return /*#__PURE__*/_jsx(MoreInfoItem, {}, param, /*#__PURE__*/_jsx(MoreInfoItemTitle, {}, void 0, formatMessage({
      id: "MenuItems.params.title.".concat(param)
    })), /*#__PURE__*/_jsx(MoreInfoItemContent, {}, void 0, Array.isArray(activeItemParams[param]) ? showList(param) : activeItemParams[param]));
  })));
}

export default /*#__PURE__*/memo(CardItemMoreInfo);